<div class="selected-item-indicator" (transitionend)="onTransitionEnd()"></div>

<div class="items-wrapper">
	<ng-content></ng-content>
</div>
